// extracted by mini-css-extract-plugin
export var fontBold = "npn9kaAC8W_oVwMPRrpn";
export var fontMedium = "GISloibV9J1f324Ns9AX";
export var fontRegular = "gX6gMNqQmFecBnlXojiC";
export var fontSemiBold = "NlC7bNL0ikgKjHFrogIY";